import { CustomReactSelectOption } from '@components/custom-react-select'
import { useAuthenticatedUser } from '@components/hooks/use-authenticated-user'
import { createSelectOption } from '@helpers/utils'
import { UserPermission } from '@models/dashboard'
import { useHrAppData } from '@modules/hr/use-hr-app-data'

export const useHrResortOptions = (): CustomReactSelectOption[] => {
  const user = useAuthenticatedUser()
  const { resorts } = useHrAppData()
  const allResortOptions = resorts.map(resort => createSelectOption(resort.name, resort.id))

  return user.hasPerm(UserPermission.HrAgreementCanSelectAnyResort)
    ? allResortOptions
    : allResortOptions.filter(resort => user.resort_ids.includes(resort.value))
}
